export default {
  dashboard: {
    name: "이름",
    template: "대시 보드 템플릿",
    dashboardWidget: "Dashboard Widgets",
    dashboardItem: "Dashboard Items",
    searchItem: "Search Fields",
    title: "Title",
    contentTemplate: "Content Template",
    colCount: "Column Count",
    sqlQuery: "SQL Query",
    enabledPagination: "Enable Pagination",
    active: "Active",
    tableName: "Table Name",
    fieldName: "Field Name",
    fieldType: "Field Type",
    columnName: "Column Name",
    columnType: "Column Type",
    groupType: "Group Type",
    orderValue:"Order Value",
    widthClass:"Width Style",
    availableParams: "Params for SQL Query",
    controlType: "Control Type",
    optionType: "Option Type",
    optionValue: "Option Value",
    templateTitle: "Template Title",
    layout: "Layout",
    updatedAt: "Last Modified",
    defaultRowCount: "Default Row Count",
    defaultColCount: "Default Column Count",
    defaultLoadingInterval: "Default Loading Interval",
    loadingInterval: "Loading Interval",
    defaultDateRange: "Default date Range",
    enabledSearch: "Enable Search",
    enabledExcel: "Enable Excel",
    enabledPrint: "Enable Print",
    generatedSql:"Generated SQL",
    executeQuery:"Execute Query",
    paramsNote:"Note: Params should be put on block {} to be removed when empty.",
    paramsNoteEx:"Ex: {AND fieldName = :fieldName}",
    queryResult:"Query Result",
    errorMessage:"Error Message",
    executionTime:"Execution Time",
    resultColumns: "Result Columns",
    editColumn: "Edit Column",
    enableRender: "Enable Replacing By Label",
    renderValues: "Value-Label Mapping",
    enableLink:"Enable Link",
    linkUrl:"Link Path",
    linkParams:"Link Params",
    linkMethod:"Link Method",
    value:"Value",
    displayLabel:"Display Label",
    collectionTable: "Collection Table",
    fraudTotal: "Fraud Total Page",
    fraudResponse:"Fraud Response",
    fraudResponseItem:"Fraud Response Item",
    itemLink:"Links",
    linkSql: "Link SQL",
    queryResultDetail:"Detail Query Result",
    detailSqlQuery:"Detail SQL Query",
    availableLinkParams:"Params for Link",
    key: "Key",
    linkParamName: "Param Name or Value",
    menu: "Menu",
    showOnDashboardMode:"Show On Dashboard Mode",
    widget: "대시 보드 위젯",
    createSearchField:"Create Search Field",
    editSearchField:"Edit Search Field"
  }
};
